import React from 'react';
import { RotateLoader } from 'react-spinners';

const Loader = () => {
  return (
    <div id='loader'>
        <RotateLoader color="#36d7b7" />
    </div>
  )
}

export default Loader